import { useEffect, useState } from 'react'
import style from './style.module.scss'
import Input from 'src/Components/Form/Input'
import Select from 'src/Components/Form/Select'
import { useGetClientsQuery } from 'src/redux/Api/clientsApi'
import { ICaseStudy } from 'src/utils/Interfaces/caseStudies.interface'
import { useUpdateCaseStudyMutation } from 'src/redux/Api/caseStudiesApi'
import Checkbox from 'src/Components/Form/Checkbox'

type Props = {
  data: ICaseStudy
}

type Status = 'ACTIVE' | 'INACTIVE' | 'PENDING' | 'BLOCKED'

const MainInfoForm = ({ data }: Props) => {
  const [caseStudy, setCaseStudy] = useState<Partial<ICaseStudy> | null>(null)
  const [updateStatus, setUpdateStatus] = useState(false)
  const { data: clients } = useGetClientsQuery()
  const [updateCaseStudy] = useUpdateCaseStudyMutation()

  useEffect(() => {
    setCaseStudy(data)
  }, [data])

  const handleUpdate = () => {
    if (caseStudy) {
      updateCaseStudy({
        id: caseStudy.id,
        url: caseStudy.url,
        title: caseStudy.title,
        description: caseStudy.description,
        metaTitle: caseStudy.metaTitle,
        metaDescription: caseStudy.metaDescription,
        metaKeywords: caseStudy.metaKeywords,
        clientId: caseStudy.clientId,
        status: caseStudy.status,
        banner: caseStudy.banner,
        bannerImage: caseStudy.bannerImage,
        isBlogPost: caseStudy.isBlogPost,
        readTime: caseStudy.readTime,
        breadcrumb: caseStudy.breadcrumb
      })
      setUpdateStatus(false)
    }
  }

  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(caseStudy)) {
      setUpdateStatus(true)
    } else {
      setUpdateStatus(false)
    }
  }, [caseStudy])

  return (
    <div className={style.params}>
      {caseStudy && (
        <>
          <Input
            label="Title"
            name="title"
            value={caseStudy.title}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, title: e.target.value })}
          />
          <Input
            label="Slug"
            name="slug"
            value={caseStudy.url}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, url: e.target.value })}
          />
          <Input
            label="Description"
            name="description"
            value={caseStudy.description}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, description: e.target.value })}
          />
          <Input
            label="Meta Title"
            name="meta_title"
            value={caseStudy.metaTitle}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, metaTitle: e.target.value })}
          />
          <Input
            label="Meta Description"
            name="meta_description"
            value={caseStudy.metaDescription}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, metaDescription: e.target.value })}
          />
          <Input
            label="Meta Keywords"
            name="meta_keywords"
            value={caseStudy.metaKeywords}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, metaKeywords: e.target.value })}
          />
          <Input
            label="Breadcrumb"
            name="breadcrumb"
            value={caseStudy.breadcrumb}
            className="light border"
            onChange={(e) => setCaseStudy({ ...caseStudy, breadcrumb: e.target.value })}
          />
          {clients && (
            <Select<string>
              label="Client"
              list={clients.map((client) => ({ _id: client.id.toString(), name: client.name }))}
              value={clients.find((client) => client.id === caseStudy.clientId)?.id.toString()}
              onChange={(val) => {
                setCaseStudy({ ...caseStudy, clientId: +val })
              }}
            />
          )}
          <Select<Status>
            label="Status"
            list={[
              { _id: 'ACTIVE', name: 'ACTIVE' },
              { _id: 'INACTIVE', name: 'INACTIVE' }
            ]}
            value={caseStudy.status}
            onChange={(val) => setCaseStudy({ ...caseStudy, status: val })}
          />
          <div className={style.banner}>
            <Input
              label="Read Time"
              name="read_time"
              value={caseStudy.readTime}
              className={'light border ' + style.read_time}
              onChange={(e) => setCaseStudy({ ...caseStudy, readTime: +e.target.value })}
            />
            <p>
              Blog Post
              <Checkbox
                checked={caseStudy.isBlogPost}
                onChange={(e) => setCaseStudy({ ...caseStudy, isBlogPost: e.target.checked })}
              />
            </p>
            <p>
              Banner template
              <Checkbox
                checked={caseStudy.banner}
                onChange={(e) => setCaseStudy({ ...caseStudy, banner: e.target.checked })}
              />
            </p>
            {caseStudy.banner && (
              <Input
                label="Banner Image"
                name="banner_image"
                value={caseStudy.bannerImage}
                className="light border"
                onChange={(e) => setCaseStudy({ ...caseStudy, bannerImage: e.target.value })}
              />
            )}
          </div>

          {updateStatus && (
            <button className="btn green" onClick={handleUpdate}>
              Save
            </button>
          )}
        </>
      )}
    </div>
  )
}

export default MainInfoForm
